import { RouteType } from "types/RouteType";
import LlmUsageStore from "./LlmUsageStore";

const llmUsageRoute: RouteType[] = [
  {
    name: "LlmUsage",
    path: "/ai/llm-usage",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "LLM Usage",
        enableRefreshButton: true,
        component: () => import("./LlmUsage.Header"),
      },
      body: {
        component: () => import("./LlmUsage"),
        grayBackground: true,
      },
    },
    group: "AI",
    searchAliases: ["ai usage", "costs", "spend", "tokens"],
    // LLM usage exposes aggregate spend and error rates across shared, app-wide
    // LLM credentials, so it is admin-only — hidden from non-admins.
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.llmUsageStore as LlmUsageStore;
      store?.load();
    },
  },
];

export default llmUsageRoute;
